export default __webpack_public_path__ + "static/media/Number_check_dark.50d5baf1.svg";